<template>
  <!--begin::General Widget 1-->
  <v-container class="mb-10">
    <h3 class="card-title align-items-start flex-column pb-3">
      <span class="card-label page-title fw-bolder fs-3 mb-1"
        >Manage Unpacked Items</span
      >
    </h3>
    <v-data-table
      :headers="tableHeaders"
      :items="processedItems"
      :expanded.sync="expanded"
      item-key="pybNumber"
      show-expand
      class="elevation-1"
      :loading="loading"
      loading-text="Loading Unpacked Items"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="p-0">
          <CustomerItemTable class="elevation-10" :customerItems="item" @update="getItems"/>
        </td>
      </template>
    </v-data-table>
  </v-container>
  <!--end::General Widget 1-->
</template>
<script>
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import ItemSummary from "@/components/ItemSummary.vue";
import CustomerItemTable from "@/components/CustomerItemTable.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManageUnpackedItems",
  data() {
    return {
      loading: false,
      items: [],
      expanded: [],
      tableHeaders: [
        {
          text: "Customer Name",
          value: "name",
        },
        { text: "PYB Number", value: "pybNumber" },
        { text: "Number of Items", value: "numItems" },
      ],
    };
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
    ItemSummary,
    CustomerItemTable,
  },
  computed: {
    processedItems() {
      if (this.items)
        this.items.forEach((element) => {
          element.numItems = element.items.length;
        });
      return this.items;
    },
  },
  methods: {
    async getItems() {
      try {
        this.loading = true;
        const result = await ApiService.Instance.getAllCustomerItems();
        if (result) this.items = result.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        error(e);
      }
    },
    async completeOption(pybNumber, itemId) {
      try {
        const result = await ApiService.Instance.confirmCustomerItemOption({
          pybNumber,
          itemId,
        });
        if (result) await this.getItems;
      } catch (e) {
        error(e);
      }
    },
  },
  async beforeMount() {
    try {
      await this.getItems();
    } catch (e) {
      error(e);
    }
  },
});
</script>